import * as Api from "@modules/api";

interface ProductProps {
  data: Api.Server.ProductGroupProductOutput;
  isSelected: boolean;
  action?: (data: Api.Server.ProductGroupProductOutput) => void;
}

export const Product = ({ data, isSelected, action }: ProductProps) => {
  const { amount, initialAmount, priceSuffix, currencyCode, badge } = data;

  return (
    <div className="relative h-full w-full">
      {badge ? (
        <div
          className={`dark:bg-dark-primary absolute left-0 top-[-26px] h-[68px] w-full rounded-[10px] bg-primary pt-1 text-center text-[12px] font-medium leading-[18px] text-white shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)]`}
        >
          {badge}
        </div>
      ) : null}
      <div
        className={`dark:border-dark-primary absolute left-0 top-0 h-[68px] w-full cursor-pointer rounded-[10px] border border-primary px-4 py-2 ${
          isSelected
            ? "bg-[#D7EDF0] dark:bg-[#496789]"
            : "bg-white dark:bg-dark_background"
        } flex items-center justify-between`}
        style={{ WebkitTapHighlightColor: "transparent" }}
        onClick={() => {
          action && action(data);
        }}
      >
        <h1
          className={`text-center text-[16px] font-bold leading-[19px] ${isSelected ? "text-black dark:text-white" : "dark:text-dark-primary text-primary"}`}
        >
          {data.name}
        </h1>
        <div
          className={`relative flex h-full w-[168px] flex-col items-start justify-center border-r border-black pr-2 dark:border-white`}
        >
          <div className="flex items-center justify-center text-black dark:text-white">
            <div className="flex text-[16px] font-medium leading-[19px]">
              <div>{currencyCode}</div>
              <div className="">
                {!initialAmount
                  ? amount?.toFixed(2)
                  : initialAmount?.toFixed(2)}
              </div>
            </div>
            <div className="text-[16px] font-medium leading-[19px]">
              <span>{priceSuffix || "/مرة واحدة"}</span>
            </div>
          </div>
          {initialAmount ? (
            <div className="mt-[3px] flex items-center justify-center text-[16px] font-medium leading-[19px] text-[#979797] line-through decoration-[#FF0000]">
              <div>{currencyCode}</div>
              <div className="">{amount?.toFixed(2)}</div>
              <div className="">
                <span>{priceSuffix}</span>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
